import React from 'react';
import VehicleConfiguratorStore from '../../_flux/stores/vehicle_configurator_store';
import {
    setLoadingCheckAction,
    setLoadingCheckDoneAction,
    setOutOfStockAction,
    setInStockAction,
    setTyresAction
} from '../../_flux/actions/vehicle_configurator_actions';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { requestVehicleConfiguratorOptions } from '../../_modules/requests/request_vehicle_configurator_options';
import { resetFiltersAfterFilter } from './reset_filters_after_change';
import { Filters } from '../../_flux/constants/filter/filters';

export function checkFor(filters, fieldsToBeChecked, changedFilter) {
    setLoadingCheckAction(fieldsToBeChecked);
    resetFiltersAfterFilter(changedFilter);
    requestVehicleConfiguratorOptions(fieldsToBeChecked, filters)
        .then((response) => {
            setLoadingCheckDoneAction();
            if (response[fieldsToBeChecked].length) {
                if (VehicleConfiguratorStore.getState().outOfStock) {
                    setInStockAction();
                }
            } else {
                setOutOfStockAction(changedFilter);
            }
            updateFilterOptionsAction(response);
        })
        .catch(error => {
            setLoadingCheckDoneAction();
            setOutOfStockAction('generic-error-message');
        });
}
